import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  gridDisplay: {
    position: 'absolute',
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridTemplateRows: 'repeat(16, 1fr)',
    gap: '1px',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'color-mix(in srgb, var(--color-neutral-200) 200%, transparent)',
    opacity: 0.25,
    pointerEvents: 'none'
  },
  gridItem: {
    backgroundColor: 'var(--color-neutral-600)'
  }
}))

export const GridLines = ({
  cols, rows
}) => {
  const classes = useStyles()

  const area = useMemo(() => {
    if (typeof cols === 'undefined' || typeof rows === 'undefined') return 192
    return cols * rows
  }, [cols, rows])

  return (
    <div className={classes.gridDisplay}>
      <div
        style={{
          gap: '1px',
          display: 'grid',
          gridTemplateRows: `repeat(${rows}, 1fr)`,
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gridArea: `1 / 1 / ${rows ?? 1} span / ${cols ?? 1} span`
        }}
      >
        {Array.from({ length: area })?.map((_, i) => (
          <div key={i} className={classes.gridItem} />
        ))}
      </div>
    </div>
  )
}

GridLines.propTypes = {
  cols: PropTypes.number,
  rows: PropTypes.number
}
